import { useQuery } from "react-query";
import servicesUtils from "../utils/servicesUtils";
var useGetSignedUrlFromS3Url = function useGetSignedUrlFromS3Url(patientUid, s3Url) {
  return useQuery(["signed-url", patientUid, s3Url], function () {
    return servicesUtils.getService("/patients/".concat(patientUid, "/upload/?s3_path=").concat(s3Url));
  }, {
    enabled: !!s3Url && !!patientUid
  });
};
export default useGetSignedUrlFromS3Url;